import { Box, styled } from '@mui/material';

export const Item = styled(Box)<{ $highlighted?: boolean }>(({ theme, $highlighted }) => ({
  display: 'flex',
  gap: '8px',
  paddingBottom: '6px',
  borderRadius: '8px',
  boxShadow: $highlighted
    ? `0 0 0 2px ${(theme.palette as any).accent.main}`
    : '0 0 0 2px transparent',
  transition: 'box-shadow 1s ease-in-out',
}));

export const ContentBox = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const HeaderBox = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  marginBottom: '6px',
  position: 'relative',
}));

export const AuthorName = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey[900],
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
  fontFamily: '"Neue Frutiger World", sans-serif',
}));

export const TimeAgo = styled('span')(({ theme }) => ({
  color: theme.palette.grey[800],
  fontSize: '0.625rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  fontFamily: '"Neue Frutiger World", sans-serif',
  whiteSpace: 'nowrap',
}));

export const Message = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey[900],
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
  fontFamily: '"Neue Frutiger World", sans-serif',
  wordBreak: 'break-word',
  whiteSpace: 'pre-line',
}));
